/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2025-04-15T17:15:33.305
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'report-reportmonthrenthousebig-'

export default 
{
path: '/report/reportmonthrenthousebig',
name: 'report-reportmonthrenthousebig',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}reportmonthrenthousebig-index',

meta:{
...meta,
title: '房态报表（定时生成）'
},

component: () => import('@/pages/report/reportmonthrenthousebig/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}reportmonthrenthousebig-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '房态报表（定时生成）编辑'
},

component: () => import('@/pages/report/reportmonthrenthousebig/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}reportmonthrenthousebigdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '房态报表（定时生成）新增'
},

component: () => import('@/pages/report/reportmonthrenthousebig/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}reportmonthrenthousebigView',
auth: [
'hidden'
],

meta:{
...meta,
title: '房态报表（定时生成）详情查看'
},

component: () => import('@/pages/report/reportmonthrenthousebig/detail-view') ,
},
]
};
